export const YT_VIDEO_CLASSNAME = 'js-youtube-video';
export const YT_VIDEO_IFRAME_API = 'https://www.youtube.com/iframe_api';
export const YT_VIDEO_DATA_ID = 'data-youtubeID';
export const YT_VIDEO_CONTEXT_ELEMENT = '.js-video-context';
export const YT_VIDEO_PAUSE_BTN = '.js-pause-youtube';
export const YT_VIDEO_PLAY_BTN = '.js-play-youtube';

export const YT_VIDEO_OPTIONS = {
  CONTROLS: 'data-controls',
  AUTOPLAY: 'data-autoplay',
  MUTE: 'data-mute',
  LOOP: 'data-loop',
};
export interface YouTubeOnStateChangeEvent {
  data: number;
  target: never;
}
